'use strict'

angular.module('webremote.debug', [])
require('./controller_methodClasses')
require('./controller_objectClasses')
require('./controller_tabs')
